import {
  DEFAULT_CHATBOT_TAB,
  resolveChatbotTabPath,
} from '../../features/chatbots/chatbotTabs';
import type { AccessibleChatbotWithIdentity } from '../../types/chatbot';

export function compareAccessibleChatbotsByStampDesc(
  left: AccessibleChatbotWithIdentity,
  right: AccessibleChatbotWithIdentity,
): number {
  const leftTime = left.chatbot.stamp ? Date.parse(left.chatbot.stamp) : 0;
  const rightTime = right.chatbot.stamp ? Date.parse(right.chatbot.stamp) : 0;
  return rightTime - leftTime;
}

export function resolveChatbotListPath(chatbotId: string): string {
  return resolveChatbotTabPath(chatbotId, DEFAULT_CHATBOT_TAB);
}
